(() => {
  const getHandleFromQuickBuyAttr = (handleAttr) => {
    if (!handleAttr) return null;
    const path = handleAttr.startsWith('/') ? handleAttr : `/products/${handleAttr}`;
    const match = path.split('?')[0].match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  const getActivePreorderButton = (form) =>
    form?.querySelector('.gPreorderBtnLoaded, .ajaxPreorderBtn, .themePreorderBtn');

  const syncBackInStockVisibility = (root, hidden) => {
    root.querySelectorAll(
      '.product-info__block-item[data-block-type="back-in-stock"], .product-info__back-in-stock'
    ).forEach((el) => {
      el.style.display = hidden ? 'none' : '';
    });
  };

  const sectionHasServerPreorderBlock = (root) =>
    Boolean(root?.querySelector('.product-info__custom-inventory--preorder'));

  const resetInjectedPreorderUi = (scope) => {
    const root =
      (scope instanceof Element && scope.matches?.('.shopify-section') && scope) ||
      scope?.closest?.('.shopify-section') ||
      scope?.closest?.('quick-buy-drawer') ||
      scope;

    if (!root || sectionHasServerPreorderBlock(root)) return;

    const form =
      (scope instanceof Element && scope.matches?.('form[is="product-form"]') ? scope : null) ||
      root.querySelector?.('form[is="product-form"]');
    if (!form) return;

    form
      .querySelectorAll(
        '.ajaxPreorderBtn, .ajaxPreorderMessage, .ajaxPreorderProperty, ' +
          '.gPreorderBtnLoaded, .gPreorderTopMessageParent, ' +
          '.themePreorderBtn, .themePreorderTopMessageParent, .themePreorderProperty, .themePreorderLocale'
      )
      .forEach((el) => el.remove());

    const loadedClass = window.GloboPreorderParams?.classes?.preorderLoadedForm || 'preorderLoaded';
    form.classList.remove(loadedClass);

    form.querySelectorAll('buy-buttons > button[type="submit"]').forEach((btn) => {
      btn.style.removeProperty('display');
    });

    root.querySelectorAll('.gPreorderBottomMessage').forEach((el) => {
      el.classList.remove('hidden-preorder');
    });

    root
      .querySelectorAll('.product-info__custom-inventory:not(.product-info__custom-inventory--preorder)')
      .forEach((el) => {
        el.style.removeProperty('display');
      });

    const inventoryBlock = root.querySelector(
      '[data-block-type="inventory"]:has(.product-info__inventory)'
    );
    if (inventoryBlock) inventoryBlock.style.removeProperty('display');

    syncBackInStockVisibility(root, false);
  };

  const guardNonPreorderSection = (scope) => {
    const root =
      (scope instanceof Element && scope.matches?.('.shopify-section') && scope) ||
      scope?.closest?.('.shopify-section') ||
      scope?.closest?.('quick-buy-drawer') ||
      scope;

    if (!root || sectionHasServerPreorderBlock(root)) return;

    const form = root.querySelector('form[is="product-form"]');
    if (!form) return;

    const cleanup = () => {
      resetInjectedPreorderUi(root);
      syncPreorderUi(form, root);
    };

    cleanup();

    let tries = 0;
    const maxTries = 20;
    const timer = setInterval(() => {
      tries += 1;
      if (getActivePreorderButton(form)) cleanup();
      if (tries >= maxTries) clearInterval(timer);
    }, 250);

    const observer = new MutationObserver(() => {
      if (getActivePreorderButton(form)) cleanup();
    });
    observer.observe(form, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      clearInterval(timer);
    }, 5000);
  };

  const syncPreorderUi = (form, scope) => {
    if (!form) return;
    const root = scope || form.closest('quick-buy-drawer') || form.closest('.shopify-section') || document;

    root.querySelectorAll('.product-info__custom-inventory:not(.product-info__custom-inventory--preorder)').forEach((el) => {
      el.style.display = '';
    });

    if (getActivePreorderButton(form)) {
      form.querySelectorAll('buy-buttons > button[type="submit"]').forEach((btn) => {
        btn.style.display = btn.matches('.gPreorderBtnLoaded, .ajaxPreorderBtn, .themePreorderBtn')
          ? ''
          : 'none';
      });
      root.querySelectorAll('.gPreorderBottomMessage').forEach((el) => {
        el.classList.add('hidden-preorder');
      });
      root.querySelectorAll('.product-info__custom-inventory--preorder').forEach((el) => {
        el.classList.add('visible-preorder');
        el.style.display = 'flex';
      });
      root.querySelectorAll('.product-info__custom-inventory:not(.product-info__custom-inventory--preorder)').forEach((el) => {
        el.style.display = 'none';
      });
      const inventoryBlock = root.querySelector(
        '[data-block-type="inventory"]:has(.product-info__inventory)'
      );
      if (inventoryBlock) inventoryBlock.style.display = 'none';
      syncBackInStockVisibility(root, true);
      return;
    }

    const themeBtn = form.querySelector('.themePreorderBtn');
    const ajaxBtn = form.querySelector('.ajaxPreorderBtn');
    if (!themeBtn && !ajaxBtn) {
      form.querySelectorAll('buy-buttons > button.button').forEach((btn) => {
        btn.style.display = '';
      });
      syncBackInStockVisibility(root, false);
      return;
    }

    if (ajaxBtn && !themeBtn) {
      form.querySelectorAll('buy-buttons > button.button:not(.ajaxPreorderBtn)').forEach((btn) => {
        btn.style.display = 'none';
      });
      ajaxBtn.style.display = '';
      root.querySelectorAll('.ajaxPreorderMessage').forEach((el) => {
        el.style.display = '';
      });
      root.querySelectorAll('.product-info__custom-inventory--preorder').forEach((el) => {
        el.classList.add('visible-preorder');
        el.style.display = 'flex';
      });
      root.querySelectorAll('.product-info__custom-inventory:not(.product-info__custom-inventory--preorder)').forEach((el) => {
        el.style.display = 'none';
      });
      syncBackInStockVisibility(root, true);
      return;
    }

    form.querySelectorAll('buy-buttons > button.button:not(.themePreorderBtn)').forEach((btn) => {
      btn.style.display = 'none';
    });
    themeBtn.style.display = '';
    root.querySelectorAll('.themePreorderTopMessageParent').forEach((el) => {
      el.style.display = '';
    });
    root.querySelectorAll('.product-info__custom-inventory--preorder').forEach((el) => {
      el.classList.add('visible-preorder');
      el.style.display = 'flex';
    });
    root.querySelectorAll('.product-info__custom-inventory:not(.product-info__custom-inventory--preorder)').forEach((el) => {
      el.style.display = 'none';
    });
    syncBackInStockVisibility(root, true);
  };

  const reinitPreorderForScope = (scope, productHandle) => {
    if (!scope) return;

    const form = scope.querySelector('form[is="product-form"]');
    if (!form) return;

    // PDP fallback button — do not re-run Globo (it strips our manual button).
    if (form.querySelector('.ajaxPreorderBtn')) {
      syncPreorderUi(form, scope);
      return;
    }

    const tryGloboInit = () => {
      const productId = form.querySelector('input[name="product-id"]')?.value;
      const globoProductIdInput = form.querySelector('.gPreorderProductId');
      if (globoProductIdInput && productId) {
        globoProductIdInput.value = productId;
      }

      const globo = window.Globo?.Preorder;
      if (!globo) return;

      try {
        if (typeof globo.loadHandles === 'function' && typeof globo.initialize === 'function') {
          globo.initialize(globo.loadHandles());
          return;
        }
        if (typeof globo.initialize === 'function') {
          if (productHandle) {
            globo.initialize([{ handle: productHandle }]);
          } else {
            globo.initialize();
          }
          return;
        }
        if (typeof globo.Index?.initialize === 'function') {
          globo.Index.initialize(productHandle ? [{ handle: productHandle }] : undefined);
        }
      } catch (error) {
        console.warn('Globo preorder re-init failed', error);
      }
    };

    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      observer.disconnect();
      clearInterval(timer);
      syncPreorderUi(form, scope);
    };

    syncPreorderUi(form, scope);

    const observer = new MutationObserver(() => {
      if (getActivePreorderButton(form)) finish();
    });
    observer.observe(form, { childList: true, subtree: true });

    let tries = 0;
    const maxTries = 16;
    const timer = setInterval(() => {
      tries += 1;
      tryGloboInit();
      if (getActivePreorderButton(form)) {
        finish();
        return;
      }
      if (tries >= maxTries) finish();
    }, 250);

    setTimeout(finish, 8000);
  };

  const initQuickBuyGallery = (root) => {
    const scope = root || document;

    scope.querySelectorAll('.product-gallery__swiper[data-swiper-id]').forEach((swiperEl) => {
      if (typeof Swiper === 'undefined') {
        setTimeout(() => initQuickBuyGallery(root), 100);
        return;
      }

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-btn--next'),
          prevEl: swiperEl.querySelector('.swiper-btn--prev'),
        },
      });
    });
  };

  const initPdpColorSwiper = (root) => {
    if (typeof Swiper === 'undefined') return;

    const scope = root || document;
    scope.querySelectorAll('[data-pdp-color-swatches]').forEach((wrapper) => {
      if (wrapper.swiper) {
        wrapper.swiper.destroy(true, true);
      }

      new Swiper(wrapper, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: wrapper.querySelector('.product-info__variations-btn--next'),
          prevEl: wrapper.querySelector('.product-info__variations-btn--prev'),
        },
      });
    });
  };

  const getViewSuffix = () => {
    if (typeof window.getPdpViewSuffix === 'function') {
      return window.getPdpViewSuffix();
    }
    try {
      const view = new URLSearchParams(window.location.search).get('view');
      return view && String(view).trim() ? String(view).trim() : null;
    } catch {
      return null;
    }
  };

  const buildDrawerHandle = (productHandle, variantId) => {
    const view = getViewSuffix();
    const params = new URLSearchParams();
    if (view) params.set('view', view);
    if (variantId) params.set('variant', variantId);
    const qs = params.toString();
    return qs ? `${productHandle}?${qs}` : productHandle;
  };

  const withViewOnProductFetch = (handleAttr) => {
    const view = getViewSuffix();
    if (!view) return handleAttr;
    if (typeof window.appendViewToHandleAttr === 'function') {
      return window.appendViewToHandleAttr(handleAttr, view);
    }
    if (String(handleAttr).includes('view=')) return handleAttr;
    const [pathPart, queryPart] = String(handleAttr).split('?');
    const params = new URLSearchParams(queryPart || '');
    params.set('view', view);
    const qs = params.toString();
    return qs ? `${pathPart}?${qs}` : pathPart;
  };

  const applyQuickBuyContent = (drawer, templateContent, productHandle) => {
    const fragment = templateContent.cloneNode(true);
    fragment.querySelectorAll('noscript').forEach((node) => node.remove());
    drawer.replaceChildren(fragment);
    drawer._hasLoaded = true;

    initQuickBuyGallery(drawer);
    initPdpColorSwiper(drawer);

    const handle =
      productHandle || getHandleFromQuickBuyAttr(drawer.getAttribute('handle'));
    reinitPreorderForScope(drawer, handle);

    if (typeof Shopify !== 'undefined' && typeof Shopify.PaymentButton?.init === 'function') {
      Shopify.PaymentButton.init();
    }
  };

  const reloadQuickBuyDrawer = async (drawer, productUrl, productHandle, swatch) => {
    if (!drawer || drawer.dataset.quickBuyLoading === 'true') return;

    const variantId = swatch?.getAttribute('data-pdp-variant-id');
    const handleAttr = buildDrawerHandle(productHandle, variantId);

    drawer.setAttribute('handle', handleAttr);
    drawer.dataset.quickBuyLoading = 'true';

    const controls = [drawer, ...(drawer.controls || [])];
    controls.forEach((el) => el.setAttribute('aria-busy', 'true'));

    try {
      const shopifyRoot = window.Shopify?.routes?.root || '/';
      const fetchHandle = withViewOnProductFetch(handleAttr);
      const response = await fetch(`${shopifyRoot}products/${fetchHandle}`);
      if (!response.ok) throw new Error(`Quick buy fetch failed: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = doc.getElementById('quick-buy-content');
      if (!template?.content) throw new Error('quick-buy-content not found');

      applyQuickBuyContent(drawer, template.content, productHandle);
    } catch (error) {
      console.error('Quick buy color reload failed:', error);
      if (productUrl) window.location.assign(productUrl);
    } finally {
      delete drawer.dataset.quickBuyLoading;
      controls.forEach((el) => el.setAttribute('aria-busy', 'false'));
    }
  };

  const syncQuickBuyDrawerFromSwatch = (card, swatch) => {
    if (!card || !swatch) return;

    const drawer = card.querySelector('quick-buy-drawer');
    if (!drawer) return;

    const handle =
      swatch.getAttribute('data-product-handle') || swatch.getAttribute('data-pdp-handle');
    const variantId =
      swatch.getAttribute('data-variant-id') || swatch.getAttribute('data-pdp-variant-id');
    if (!handle) return;

    drawer.setAttribute('handle', buildDrawerHandle(handle, variantId));
    drawer._hasLoaded = false;
  };

  const patchQuickBuyDrawerShow = () => {
    if (window.__quickBuyPreorderPatched) return;

    customElements.whenDefined('quick-buy-drawer').then(() => {
      if (window.__quickBuyPreorderPatched) return;

      const QuickBuyDrawer = customElements.get('quick-buy-drawer');
      if (!QuickBuyDrawer?.prototype?.show) return;

      const originalShow = QuickBuyDrawer.prototype.show;

      QuickBuyDrawer.prototype.show = async function patchedShow(...args) {
        const result = await originalShow.apply(this, args);

        // On the PDP, main-product-pdp.js installs a more complete show() patch
        // that already re-inits preorder after show. Skip here to avoid running
        // it twice (the two patches wrap the same method on that page).
        if (this._hasLoaded && !window.__pdpQuickBuyDrawerPatched) {
          reinitPreorderForScope(this, getHandleFromQuickBuyAttr(this.getAttribute('handle')));
        }

        return result;
      };

      window.__quickBuyPreorderPatched = true;
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      // Synthetic events (bots, in-app browsers) can target document or a text node, which have no closest().
      if (!(event.target instanceof Element)) return;
      const swatch = event.target.closest('[data-pdp-color-swatch]');
      if (!swatch) return;

      const drawer = swatch.closest('quick-buy-drawer');
      if (!drawer) return;

      const root = swatch.closest('[data-pdp-color-swap]');
      if (!root) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const handle = swatch.getAttribute('data-pdp-handle');
      const productUrl = swatch.getAttribute('data-pdp-url') || swatch.getAttribute('href');
      const currentHandle = root.getAttribute('data-current-handle');

      if (!handle || !productUrl || handle === currentHandle) return;

      reloadQuickBuyDrawer(drawer, productUrl, handle, swatch);
    },
    true
  );

  const initQuickBuyDrawer = (root) => {
    initQuickBuyGallery(root);
    initPdpColorSwiper(root);
  };

  patchQuickBuyDrawerShow();

  window.initQuickBuyGallery = initQuickBuyGallery;
  window.initPdpColorSwiper = initPdpColorSwiper;

  // Chain instead of overwrite: a prior window.initSwiper (e.g. custom.js, which
  // also runs the menu-promotion slider) must keep working. The updated custom.js
  // version already calls initQuickBuyGallery + initPdpColorSwiper, so delegating
  // to it covers the quick-buy drawer too; fall back to initQuickBuyDrawer only
  // when no earlier implementation exists.
  const previousInitSwiper = window.initSwiper;
  window.initSwiper = (root) => {
    if (typeof previousInitSwiper === 'function') {
      previousInitSwiper(root);
    } else {
      initQuickBuyDrawer(root);
    }
  };
  window.syncQuickBuyDrawerFromSwatch = syncQuickBuyDrawerFromSwatch;
  window.reloadQuickBuyDrawer = reloadQuickBuyDrawer;
  window.syncPreorderUi = syncPreorderUi;
  window.resetInjectedPreorderUi = resetInjectedPreorderUi;
  window.guardNonPreorderSection = guardNonPreorderSection;
  window.reinitPreorderForScope = reinitPreorderForScope;

})();
